import React, { useContext, useEffect } from 'react';
import { IReportsWithCustomProps } from '../../reportsContainerState/reportsContainerContext';
import { IReportsContext, ReportsContext } from './reportsContext/reportsState/reportsContext';
import InputFields from './components/InputFields/InputFields';
import ModalWindows from './components/ModalWindows/ModalWindows';
import Text from 'components/Text/Text';
import style from './ReportsForm.module.scss';

interface IReportsForm {
	report: IReportsWithCustomProps;
}

const ReportsForm: React.FC<IReportsForm> = ({ report }) => {
	const { setAllData, hasBanOnChanges } = useContext<IReportsContext>(ReportsContext);

	useEffect(() => {
		setAllData(report);
	}, [report]);

	return (
		<div className={style.container} data-test="ReportsForm">
			<div className={style.contentWrapper}>
				<InputFields />
				<ModalWindows />
				{hasBanOnChanges && (
					<div className={style.banOverlay}>
						<Text
							className={style.notice}
							translationNameSpace="form"
							translationKey="reportsBanOverlay"
							theme="secondary"
							size="xxl"
							weight="bold"
						/>
					</div>
				)}
			</div>
			<div className={style.divider} />
		</div>
	);
};

export default React.memo(ReportsForm);
